import { Deal } from '@finn/platform-modules';
import axios from 'axios';

type Props = {
  selectedSubscription: Deal | null;
  availableFrom: string;
  availableTo: string;
};
export const recommendationFetcher = async ({
  selectedSubscription,
  availableFrom,
  availableTo,
}: Props) => {
  try {
    const response = await axios.post('/api/getRecommendation', {
      id: selectedSubscription?.id,
      carId: selectedSubscription?.car?.external_product_id,
      min_date: availableFrom,
      max_date: availableTo,
    });

    return response.data;
  } catch (error) {
    console.error(error);

    return null;
  }
};
